const messages = {
    menuTitle: 'Kampanie',
    pageTitle: 'Kampanie',
    campaigns: {
        menuTitle: 'JMD',
        pageTitle: 'Kampanie / Lista kampanii',
        detailPageTitle: 'Edycja kampanii JMD',
        actions: {
            create: 'Utwórz kampanię',
            open: 'Otwórz',
            close: 'Zamknij',
            delete: 'Usuń'
        },
        details: {
            sections: {
                parameters: 'Parametry kampanii',
                products: 'Produkty',
                sets: 'Zestawy',
                distributionCenters: 'Centra dystrybucji'
            },
            fields: {
                createdAt: 'Data utworzenia',
                name: 'Nazwa',
                number: 'Numer',
                status: 'Status',
                report: 'Raport',
                labels: 'Etykiety'
            },
            tooltips: {
                generateReport: 'Generuj raport',
                generateLabels: 'Generuj etykiety'
            },
            actions: {
                backToList: 'Powrót do listy',
                createOrder: 'Nowe zamówienie',
                closeCampaign: 'Zamknij kampanię'
            }
        },
        filters: {
            search: 'Szukaj...',
            status: 'Status',
            createdAtFrom: 'Od:',
            createdAtTo: 'Do:'
        },
        table: {
            headers: {
                name: 'Nazwa',
                number: 'Numer',
                createdAt: 'Data wystawienia',
                status: 'Status',
                actions: 'Akcje'
            }
        },
        products: {
            actions: {
                addProduct: 'Dodaj produkt',
                joinOrder: 'Powiąż zamówienie',
                addFile: 'Dodaj plik',
                acceptFile: 'Akceptuj'
            },
            table: {
                headers: {
                    name: 'Nazwa',
                    jobNumber: 'Nr zlecenia',
                    format: 'Format',
                    totalAmount: 'Ilość',
                    actions: 'Akcje'
                }
            },
            tooltips: {
                removeFromJob: 'Usuń ze zlecenia',
                edit: 'Edytuj',
                delete: 'Usuń'
            },
            fileAcceptedLabel: 'ZAAKCEPTOWANE',
            dialogs: {
                removeProductFromJob: {
                    title: 'Usuwanie produktu ze zlecenia',
                    content: 'Czy na pewno chcesz usunąć produkt ze zlecenia?'
                },
                deleteProduct: {
                    title: 'Usuwanie produktu',
                    content: 'Czy na pewno chcesz usunąć produkt?'
                },
                deleteProductFile: {
                    title: 'Usuwanie pliku',
                    content: 'Czy na pewno chcesz usunąć plik?'
                }
            }
        },
        sets: {
            fields: {
                name: 'Nazwa',
                ean: 'Kod EAN',
                index: 'Index'
            },
            actions: {
                addSet: 'Dodaj zestaw',
                addProduct: 'Dodaj produkt'
            },
            table: {
                headers: {
                    name: 'Nazwa',
                    amount: 'Ilość',
                    actions: 'Akcje'
                }
            },
            tooltips: {
                generateReport: 'Rozdzielnik kompletu',
                editSet: 'Edycja zestawu',
                deleteSet: 'Usuń zestaw',
                editProduct: 'Edytuj',
                deleteProduct: 'Usuń'
            },
            dialogs: {
                deleteSet: {
                    title: 'Usuwanie zestawu',
                    content: 'Czy na pewno chcesz usunąć zestaw?'
                },
                deleteSetProduct: {
                    title: 'Usuwanie produktu',
                    content: 'Czy na pewno chcesz usunąć produkt?'
                }
            }
        },
        distributionCenters: {
            fields: {
                name: 'Nazwa'
            },
            actions: {
                addDistributionCenter: 'Dodaj centrum dystrybucji',
                addSet: 'Dodaj zestaw'
            },
            table: {
                headers: {
                    name: 'Nazwa',
                    ean: 'Kod EAN',
                    index: 'Index',
                    amount: 'Ilość',
                    actions: 'Akcje'
                }
            },
            tooltips: {
                editDistributionCenter: 'Edycja centrum dystrybucji',
                deleteDistributionCenter: 'Usuń centrum dystrybucji',
                editSet: 'Edytuj',
                deleteSet: 'Usuń'
            },
            dialogs: {
                deleteDistributionCenter: {
                    title: 'Usuwanie centrum dystrybucji',
                    content: 'Czy na pewno chcesz usunąć centrum dystrybucji?'
                },
                deleteDistributionCenterSet: {
                    title: 'Usuwanie zestawu centrum dystrybucji',
                    content: 'Czy na pewno chcesz usunąć zestaw centrum dystrybucji?'
                }
            }
        },
        dialogs: {
            addCampaign: {
                title: 'Tworzenie kampanii z pliku',
                fields: {
                    file: 'Plik'
                },
                placeholders: {
                    file: 'Wybierz plik'
                },
                actions: {
                    cancel: 'Anuluj',
                    submit: 'Utwórz kampanię'
                }
            },
            deleteCampaign: {
                title: 'Usuwanie kampanii',
                content: 'Czy na pewno chcesz usunąć kampanię?'
            },
            closeCampaign: {
                title: 'Zamknięcie kampanii',
                content: 'Czy na pewno chcesz zamknąć kampanię?'
            },
            createOrderByCampaignProduct: {
                title: 'Tworzenie nowego zamówienia',
                fields: {
                    productTemplate: 'Szablon produktu',
                    executionTemplate: 'Szablon wykonania'
                },
                placeholders: {
                    productTemplateSelect: 'Proszę wybrać szablon produktu',
                    executionTemplateSelect: 'Proszę wybrać szablon wykonania'
                },
                errors: {
                    productTemplateRequired: 'Proszę wybrać szablon produktu.',
                    executionTemplateRequired: 'Proszę wybrać szablon wykonania.'
                },
                table: {
                    headers: {
                        name: 'Nazwa',
                        format: 'Format',
                        filesCount: 'Zaakceptowane pliki',
                        amount: 'Nakład'
                    }
                },
                actions: {
                    cancel: 'Anuluj',
                    submit: 'Utwórz zamówienie'
                }
            },
            campaignProduct: {
                createTitle: 'Dodaj produkt',
                editTitle: 'Edycja produktu - ',
                fields: {
                    name: 'Nazwa produktu'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę produktu.'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            },
            campaignSet: {
                createTitle: 'Dodaj zestaw',
                editTitle: 'Edycja zestawu - ',
                fields: {
                    name: 'Nazwa zestawu',
                    ean: 'EAN zestawu',
                    index: 'Index zestawu'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę zestawu.',
                    eanRequired: 'Proszę podać EAN zestawu.',
                    indexRequired: 'Proszę podać index zestawu.'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            },
            campaignSetProduct: {
                createTitle: 'Dodaj produkt',
                editTitle: 'Edycja produktu - ',
                fields: {
                    product: 'Produkt',
                    amount: 'Ilość'
                },
                errors: {
                    productRequired: 'Proszę wybrać produkt.',
                    amountRequired: 'Proszę podać ilość produktu.',
                    amountPositiveInteger: 'Proszę podać całkowitą dodatnią liczbę produktów.'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            },
            campaignDistributionCenter: {
                createTitle: 'Dodaj centrum dystrybucji',
                editTitle: 'Edycja centrum dystrybucji - ',
                fields: {
                    name: 'Nazwa centrum dystrybucji'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę centrum dystrybucji.'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            },
            campaignDistributionCenterSet: {
                createTitle: 'Dodaj zestaw',
                editTitle: 'Edycja zestawu - ',
                fields: {
                    set: 'Zestaw',
                    amount: 'Ilość'
                },
                errors: {
                    setRequired: 'Proszę wybrać zestaw.',
                    amountRequired: 'Proszę podać ilość zestawu.',
                    amountPositiveInteger: 'Proszę podać całkowitą dodatnią liczbę zestawów.'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                }
            },
            addProductFile: {
                title: 'Dodawanie pliku',
                fields: {
                    file: 'Plik'
                },
                placeholders: {
                    file: 'Wybierz plik'
                },
                errors: {
                    invalidFileType: 'Dozwolone formaty: PDF, JPG'
                },
                actions: {
                    cancel: 'Anuluj',
                    submit: 'Dodaj plik'
                }
            },
            joinOrderToCampaign: {
                title: 'Powiązanie zamówienia z kampanią',
                filters: {
                    productionNumber: 'Numer zamówienia'
                },
                table: {
                    headers: {
                        productionNumber: 'Numer zamówienia',
                        name: 'Nazwa zamówienia',
                        jobNumber: 'Numer zlecenia',
                        actions: 'Akcje'
                    }
                },
                actions: {
                    create: 'Utwórz',
                    close: 'Zamknij'
                }
            }
        }
    },
    service: {
        notifications: {
            campaignCreated: 'Kampania została utworzona.',
            campaignClosed: 'Kampania została zamknięta.',
            campaignDeleted: 'Kampania została usunięta.',
            campaignProductFileAccepted: 'Plik produktu został zaakceptowany.',
            campaignProductCreated: 'Produkt kampanii został dodany.',
            campaignProductUpdated: 'Produkt kampanii został zaktualizowany.',
            campaignProductDeleted: 'Produkt kampanii został usunięty.',
            campaignProductFileDeleted: 'Plik produktu został usunięty.',
            campaignProductRemovedFromJob: 'Produkt został usunięty ze zlecenia.',
            campaignSetCreated: 'Zestaw kampanii został dodany.',
            campaignSetUpdated: 'Zestaw kampanii został zaktualizowany.',
            campaignSetDeleted: 'Zestaw kampanii został usunięty.',
            campaignDistributionCenterCreated: 'Centrum dystrybucji zostało dodane.',
            campaignDistributionCenterUpdated: 'Centrum dystrybucji zostało zaktualizowane.',
            campaignDistributionCenterDeleted: 'Centrum dystrybucji zostało usunięte.',
            orderCreated: 'Zamówienie zostało utworzone.',
            reportWillBeSent: 'Raport zostanie wygenerowany i przesłany na adres {userEmail}.',
            orderJoinedToCampaign: 'Zamówienie zostało przypisane do kampanii.'
        },
        errors: {
            fetchCampaigns: 'Pobranie listy kampanii nie powiodło się.',
            fetchCampaign: 'Pobranie danych kampanii o id {id} nie powiodło się.',
            fetchCampaignStatuses: 'Pobranie statusów kampanii nie powiodło się.',
            createCampaignByFile: 'Tworzenie kampanii nie powiodło się.',
            deleteCampaign: 'Usunięcie kampanii nie powiodło się.',
            updateCampaign: 'Edycja kampanii nie powiodła się.',
            deleteCampaignProduct: 'Usunięcie produktu kampanii nie powiodło się.',
            createCampaignProduct: 'Dodanie produktu kampanii nie powiodło się.',
            updateCampaignProduct: 'Edycja produktu nie powiodła się.',
            removeCampaignProductFromJob: 'Usunięcie produktu ze zlecenia nie powiodło się.',
            addCampaignProductFile: 'Dodanie pliku nie powiodło się.',
            deleteCampaignProductFile: 'Usunięcie pliku produktu nie powiodło się.',
            acceptCampaignProductFile: 'Akceptacja pliku produktu nie powiodła się.',
            createCampaignSet: 'Dodanie zestawu kampanii nie powiodło się.',
            updateCampaignSet: 'Edycja zestawu kampanii nie powiodła się.',
            deleteCampaignSet: 'Usunięcie zestawu kampanii nie powiodło się.',
            createCampaignDistributionCenter: 'Dodanie centrum dystrybucji nie powiodło się.',
            updateCampaignDistributionCenter: 'Edycja centrum dystrybucji nie powiodła się.',
            deleteCampaignDistributionCenter: 'Usunięcie centrum dystrybucji nie powiodło się.',
            fetchCampaignDistributionCenter: 'Pobranie centrów dystrybucji nie powiodło się.',
            fetchProductTemplates: 'Pobranie szablonów produktów nie powiodło się.',
            fetchImpositionProductTypeConfigurations: 'Pobranie konfiguracji nie powiodło się.',
            createOrderByProduct: 'Utworzenie zamówienia nie powiodło się.',
            generateCampaignReport: 'Wygenerowanie raportu nie powiodło się.',
            generateProductSetReport: 'Wygenerowanie raportu nie powiodło się.',
            generateCampaignLabelsReport: 'Wygenerowanie raportu nie powiodło się.',
            fetchCampaignOrdersToLink: 'Pobranie zamówień kampanii nie powiodło się.',
            joinOrderToCampaign: 'Przypisanie zamówienia do kampanii nie powiodło się.'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
